import { Component, Input } from '@angular/core';

import { navItems } from './_nav_backup';
import { AuthService } from 'src/app/auth/auth.service';
import { INavData } from '@coreui/angular';
import { RolesService } from 'src/app/auth/roles.service';
import { HeaderService } from 'src/app//helpers/headerService';

// import {FilterSidebarComponent} from '../../views/filter/filter-sidebar/filter-sidebar.component'

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent {
  // public navItems = navItems;
  // isFilterSidebarOpen = false;

  @Input() sidebarId: string = 'sidebar';
  public navItems: INavData[] = [];
  userRole!: string;
  selectedRole!: string;

  constructor(private authService: AuthService, private role: RolesService,private headerService: HeaderService) { }

  ngOnInit() {
    this.authService.userRole$.subscribe((response: any) => {
      if (response) {
        this.userRole = response;
      }
      this.headerService.headerStatus$.subscribe(status => {
        if(status !=''){
          this.selectedRole = status;
          this.updateSideNavVisibility();
        }
      });
    });

    const selectedRole = localStorage.getItem('selectedRole');
    const role = localStorage.getItem('role');
    if (role) {
      this.userRole = role;
    }
    if(selectedRole){
      this.selectedRole = selectedRole;
    }else{
      this.selectedRole = '';
    }
    this.updateSideNavVisibility();
  

  }

  updateSideNavVisibility(){
     if (this.role.superCDDRole()&&(this.selectedRole=='IDN'||this.selectedRole=='')) {
      this.navItems = [
        {
          title: true,
          name: 'Dashboard',
        },
        {
          name: 'My Dashboard',
          url: '/dashboard',
          iconComponent: { name: 'cil-speedometer' },
          linkProps: { routerLinkActiveOptions: { exact: true } },
        },
        {
          name: 'Cluster Dashboard ',
          url: '/dashboard/cluster-dashboard',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Executive Dashboard ',
          url: '/dashboard/cdd-reports',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'CDD Dashboard ',
          url: '/dashboard/cdd-dashboard-report',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Influenza Dashboard ',
          url: '/dashboard/influenza-dashboard-report',
          iconComponent: { name: 'cil-speedometer' },
        },
        // {
        //   name: 'AMR Dashboard ',
        //   url: '/dashboard/amr-dashboard',
        //   iconComponent: { name: 'cil-speedometer' },
        // },

        {
          title: true,
          name: 'IDN Management',
        },
        {
          name: 'Case Management',
          url: '/main-forms/case-view-form',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Patient Management',
          url: '/dashboard/patient-managment',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Health Event Monitor',
          url: '/main-forms/case-view-specific-form',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Cluster Management',
          url: '/dashboard/cluster-management',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Contact Exposures',
          url: '/dashboard/contact-exposures-view',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Facilites',
          url: '/dashboard/facilites-view',
          iconComponent: { name: 'cil-speedometer' },
        },
       
        // {
        //   name: 'Patient Management',
        //   url: '/dashboard/patient-management',
        //   iconComponent: { name: 'cil-speedometer' },
        // },
        // {
        //   title: true,
        //   name: 'AMR Management',
        // },
        // {
        //   name: 'AMR Case Management',
        //   url: '/dashboard/amr-case-management',
        //   iconComponent: { name: 'cil-speedometer' },
        // },
        // {
        //   name: 'Files',
        //   url: '/dashboard/amr-files',
        //   iconComponent: { name: 'cil-speedometer' },
        // },
        {
          title: true,
          name: 'Disease Management',
        },

        {
          name: 'Groups',
          url: '/dashboard/disease-group',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Components',
          url: '/dashboard/disease-component',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Integration List',
          url: '/dashboard/target-disease',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'Advance Search',
        },
        {
          name: 'ICA Search',
          url: '/search/icasearch',
          iconComponent: { name: 'cil-star' },
        },
        {
          name: 'Advanced Search',
          url: '/search/case-search',
          iconComponent: { name: 'cil-star' },
        },
        // {
        //   name: 'Family Book',
        //   url: '/dashboard/family-book',
        //   iconComponent: { name: 'cil-star' },
        // },
        {
          title: true,
          name: 'Configuration',
        },
        {
          name: 'SMS Management',
          url: '/dashboard/sms-management',
          iconComponent: { name: 'cil-envelope-closed' },
        },
        {
          name: 'Email Management',
          url: '/dashboard/email-management',
          iconComponent: { name: 'cil-envelope-open' },
        },
        {
          name: 'Template Management',
          url: '/dashboard/template-management',
          iconComponent: { name: 'cil-star' },
        },
        {
          name: 'System Setting',
          url: '/dashboard/system-setting',
          iconComponent: { name: 'cil-star' },
        },

        {
          title: true,
          name: 'User Management',
        },
        {
          name: 'Users',
          iconComponent: { name: 'cil-user' },
          children:[
            {
              name:'CDD User',
              url:'/main-forms/cdd-user-management',
              iconComponent: { name: 'cil-user' }
            },
            {
              name:'AMR User',
              url:'/main-forms/amr-user-management',
              iconComponent: { name: 'cil-user' }
            },
            // {
            //   name:'Role Requests',
            //   url:'/dashboard/app-request',
            //   iconComponent: { name: 'cil-user' }
            // }
        ]
        },
        // {
        //   name: 'CDD User',
        //   url: '/main-forms/cdd-user-management',
        //   iconComponent: { name: 'cil-star' },
        // },
        {
          name: 'Teams',
          url: '/main-forms/teams-view-form',
          iconComponent: { name: 'cil-star' },
        },
        {
          name: 'Facility Members',
          url: '/dashboard/facility-members',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'Bulk Monitoring',
        },
        {
          name: 'Bulk Operations',
          url: '/main-forms/bulk-monitoring',
          iconComponent: { name: 'cil-star' },
        },
      ];
    }
    else if (this.role.amrSuperRole() &&(this.selectedRole=='AMR'||this.selectedRole=='')) {
      this.navItems = [
        {
          title: true,
          name: 'AMR Management',
        },
        // {
        //   name: 'AMR Dashboard ',
        //   url: '/dashboard/amr-dashboard',
        //   iconComponent: { name: 'cil-speedometer' },
        // },
        {
          name: ' AMR Dashboard ',
          url: '/dashboard/amr-dashboard',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'AMR Management',
        },
        {
          name: 'AMR Case Management',
          url: '/dashboard/amr-case-management',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Files',
          url: '/dashboard/amr-files',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'User Management',
        },
        {
          name: 'Facility Members',
          url: '/dashboard/facility-members',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Users',
          iconComponent: { name: 'cil-user' },
          children:[
            {
              name:'CDD User',
              url:'/main-forms/cdd-user-management',
              iconComponent: { name: 'cil-user' }
            },
            {
              name:'AMR User',
              url:'/main-forms/amr-user-management',
              iconComponent: { name: 'cil-user' }
            },
            // {
            //   name:'Role Requests',
            //   url:'/dashboard/app-request',
            //   iconComponent: { name: 'cil-user' }
            // }
        ]
        },
        // {
        //   name: 'CDD User',
        //   url: '/main-forms/cdd-user-management',
        //   iconComponent: { name: 'cil-star' },
        // },
        {
          title: true,
          name: 'Configuration',
        },
        // {
        //   name: 'System Setting',
        //   url: '/dashboard/system-setting',
        //   iconComponent: { name: 'cil-star' }
        // },
        {
          name: 'Bulk Operations',
          url: '/main-forms/bulk-monitoring',
          iconComponent: { name: 'cil-star' },
        }
      ];
    }
    else if (this.role.CDDUser()&&(this.selectedRole=='IDN'||this.selectedRole=='')) {
      this.navItems = [
        {
          title: true,
          name: 'Dashboard',
        },
        {
          name: 'Dashboard',
          url: '/dashboard',
          iconComponent: { name: 'cil-speedometer' },
          linkProps: { routerLinkActiveOptions: { exact: true } },
        },
        {
          name: 'Cluster Dashboard ',
          url: '/dashboard/cluster-dashboard',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'IDN Management',
        },
        {
          name: 'Case Management',
          url: '/main-forms/case-view-form',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Patient Management',
          url: '/dashboard/patient-managment',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Health Event Monitor',
          url: '/main-forms/case-view-specific-form',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Cluster Management',
          url: '/dashboard/cluster-management',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Executive Dashboard ',
          url: '/dashboard/cdd-reports',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'CDD Dashboard ',
          url: '/dashboard/cdd-dashboard-report',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Influenza Dashboard ',
          url: '/dashboard/influenza-dashboard-report',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Facility Members',
          url: '/dashboard/facility-members',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'Advance Search',
        },
        {
          name: 'ICA Search',
          url: '/search/icasearch',
          iconComponent: { name: 'cil-star' },
        },
        {
          name: 'Advanced Search',
          url: '/search/case-search',
          iconComponent: { name: 'cil-star' },
        },
        // {
        //   name: 'Family Book',
        //   url: '/dashboard/family-book',
        //   iconComponent: { name: 'cil-star' },
        // },
        {
          title: true,
          name: 'Configuration',
        },
        {
          name: 'SMS Management',
          url: '/dashboard/sms-management',
          iconComponent: { name: 'cil-envelope-closed' },
        },
        {
          name: 'Email Management',
          url: '/dashboard/email-management',
          iconComponent: { name: 'cil-envelope-open' },
        },
        {
          title: true,
          name: 'Bulk Monitoring',
        },
        {
          name: 'Bulk Operations',
          url: '/main-forms/bulk-monitoring',
          iconComponent: { name: 'cil-star' },
        },
      ];
    }
    else if (this.role.CDDBasicUser()&&(this.selectedRole=='IDN'||this.selectedRole=='')) {
      this.navItems = [
        {
          title: true,
          name: 'Dashboard',
        },
        {
          name: 'Dashboard',
          url: '/dashboard',
          iconComponent: { name: 'cil-speedometer' },
          linkProps: { routerLinkActiveOptions: { exact: true } },
        },
        {
          name: 'Cluster Dashboard ',
          url: '/dashboard/cluster-dashboard',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'IDN Management',
        },
        {
          name: 'Case Management',
          url: '/main-forms/case-view-form',
          // badge: {
          //   color: 'info',
          //   text: 'NEW',
          // },
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Patient Management',
          url: '/dashboard/patient-managment',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Health Event Monitor',
          url: '/main-forms/case-view-specific-form',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Cluster Management',
          url: '/dashboard/cluster-management',
          iconComponent: { name: 'cil-speedometer' },
        },
        // {
        //   name: 'Patient Management',
        //   url: '/dashboard/patient-management',
        //   iconComponent: { name: 'cil-speedometer' },
        // },
        // {
        //   name: 'Facility Members',
        //   url: '/dashboard/facility-members',
        //   iconComponent: { name: 'cil-speedometer' },
        // },
        {
          title: true,
          name: 'Advance Search',
        },
        {
          name: 'ICA Search',
          url: '/search/icasearch',
          iconComponent: { name: 'cil-star' },
        },
        {
          name: 'Advanced Search',
          url: '/search/case-search',
          iconComponent: { name: 'cil-star' },
        },
        // {
        //   name: 'Family Book',
        //   url: '/dashboard/family-book',
        //   iconComponent: { name: 'cil-star' },
        // },
        {
          title: true,
          name: 'Configuration',
        },
        {
          name: 'SMS Management',
          url: '/dashboard/sms-management',
          iconComponent: { name: 'cil-envelope-closed' },
        },
        {
          name: 'Email Management',
          url: '/dashboard/email-management',
          iconComponent: { name: 'cil-envelope-open' },
        },
      ];
    }
    else if (this.role.amrFacility()&&(this.selectedRole=='AMR'||this.selectedRole=='')) {
      this.navItems = [
        {
          title: true,
          name: 'AMR Management',
        },
        {
          name: 'Files',
          url: '/dashboard/amr-files',
          iconComponent: { name: 'cil-speedometer' },
        },
      ];
    }
    else if (this.role.amrBasicRole()&&(this.selectedRole=='AMR'||this.selectedRole=='')) {
      this.navItems = [
        {
          title: true,
          name: 'AMR Management',
        },
        // {
        //   name: 'AMR Dashboard ',
        //   url: '/dashboard/amr-dashboard',
        //   iconComponent: { name: 'cil-speedometer' },
        // },
        {
          name: ' AMR Dashboard ',
          url: '/dashboard/amr-dashboard',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          title: true,
          name: 'AMR Management',
        },
        {
          name: 'AMR Case Management',
          url: '/dashboard/amr-case-management',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Files',
          url: '/dashboard/amr-files',
          iconComponent: { name: 'cil-speedometer' },
        },
      ];
    }
    else if (this.role.idnFacility()) {
      this.navItems = [
        {
          title: true,
          name: 'IDN Management',
        },
        {
          name: 'IDN Notifications',
          url: '/dashboard/idn-notifications',
          iconComponent: { name: 'cil-speedometer' },
        },
        {
          name: 'Facility Members',
          url: '/dashboard/facility-members',
          iconComponent: { name: 'cil-speedometer' },
        },
      ];
    }
  }
}
